import { defineStore } from "pinia";
import { ref, onMounted } from "vue";

export const useListenConfigStore = defineStore("listenConfig", {
  state: () => {
    return {
      volume:localStorage.getItem("listenAudioVolume") || 70, //音量
      playbackRate: localStorage.getItem("listenPlaybackRate") || 1,  //播放速率
      showTranslate: false,
      theme: localStorage.getItem("listenTheme") || "green",
      fontSize: localStorage.getItem("listenFontSize") || 'font_medium',
      recorder:null,
      listenPrepare:false,  //是否是备课状态
    };
  },
  actions: {
    setVolume(val) {
      this.volume = val;
      localStorage.setItem("listenAudioVolume", val);
    },
    setPlaybackRate(val) {
      this.playbackRate = val;
      localStorage.setItem("listenPlaybackRate", val);
    },
    setShowTranslate(val) {
      this.showTranslate = val;
    },
    setTheme(val) {
      this.theme = val;
      localStorage.setItem("listenTheme", val);
    },
    setFontSize(val) {
      this.fontSize = val;
      localStorage.setItem("listenFontSize", val);
    },
    setRecorder(val) {
      this.recorder = val;
    },
    resetRecord(){
      console.log(this.recorder);
      if(this.recorder?._status){
        this.recorder.reset()
      }
    },
    setListenPrepare(val){
      this.listenPrepare = val;
    },
  },
});
